import React from 'react'
import { queryFake } from '../../../utils/initValues'
import { useGetStores } from '../../../utils/badaAppointmentApi'
import { calcDistance } from '../../../utils/distance'

const fetchStores = (Wrapped) => {
  const Comp = ({ storeId, selectedAddress, fallbackAddress, ...rest }) => {
    const latitude = selectedAddress?.latitude || fallbackAddress?.latitude
    const longitude = selectedAddress?.longitude || fallbackAddress?.longitude

    const { data, error, isLoading } = useGetStores(
      !!queryFake || parseInt(storeId, 10) < 0
    )

    const storesByAddressData = {
      error,
      loading: isLoading,
      stores:
        data?.map((s) => ({
          store: s,
          ...calcDistance(latitude, longitude, s.latitude, s.longitude),
        })) || null,
    }

    const StoreWithDistance = {
      variables: { storeId },
      error,
      store:
        data &&
        storeId !== undefined &&
        storeId !== null &&
        storeId !== ''
          ? {}
          : null,
    }

    return (
      <Wrapped
        {...rest}
        storeId={storeId}
        fallbackAddress={fallbackAddress}
        selectedAddress={selectedAddress}
        storesByAddressData={storesByAddressData}
        StoreWithDistance={StoreWithDistance}
      />
    )
  }

  Comp.displayName = 'FetchStoresComponent'

  return Comp
}

export { fetchStores }
